import LabServiceModel from "@/models/LabServiceModel";
import AnalyteCollection from "../../collections/lab/AnalyteCollection";
import TestPackageModel from "./TestPackageModel";
import SampleTestPackageCollection from "../../collections/lab/SampleTestPackageCollection";
import TestPackageAnalyteCollection from "../../collections/lab/TestPackageAnalyteCollection";
import TestPackageCollection from "../../collections/lab/TestPackageCollection";

export default class TestPackageSampleModel extends LabServiceModel {

  modelName() {
    return 'test-package-sample';
  }

  defaults() {
    return {
      id: null,
      test_package_id: null,
      test_package: null,
      name: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      sample_test_packages: [],
      test_package_analytes: [],
      analytes: [],
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      test_package_id: (val) => (this.nullStringMutator(val)),
      name: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val))
    }
  }

  // Attribute validation
  validation() {
    return {}
  }


  getTestPackage() {
    return this.getRelatedModel(TestPackageModel, 'test_package');
  }

  getSampleTestPackages() {
    return this.getRelatedCollection((new SampleTestPackageCollection()), 'sample_test_packages');
  }

  getTestPackageAnalytes() {
    return this.getRelatedCollection((new TestPackageAnalyteCollection()), 'test_package_analytes');
  }

  getAnalytes() {
    return this.getRelatedCollection((new AnalyteCollection()), 'analytes');
  }

}
